 /* eslint-disable */
<template>
  <div class="search_case_lists">
    <AdminNavigation v-if="user.type >= 3" ref="navigation" indexProps="5" />
    <Navigation v-else indexProps="4" />
    <ProfileReadMoreModal ref="profileReadMoreModal" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>{{ setTitle() }}</h1></div>
        <div class="header-sub-title">
          <span v-if="showResult">Either choose an existing case, or create a new case by entering the claimant details.</span>
          <span v-else>Has the claimant attended an appointment before?  Please search below.</span>
        </div>
      </div>
    </div>
    <div class="panel">
      <AdminBookingsMenu  v-if="user.type >= 3" indexProps="0" />
      <SpecialistMenu v-else indexProps="0" />
      <div class="content" v-if="showContent">
        <div class="top-detail">
          <div class="row m-0">
            <div class="col p-0 center-title">
              <div class="row center-title m-0 display-in-row" v-if="!bookingProps.isSupplementary">
                <div class="col-2 p-0">
                  <div class="border-image">
                    <div class="border-image-number">{{formatDateTime(bookingProps.bookingDate, 'DD')}}</div>
                    <div class="border-image-text">{{formatDateTime(bookingProps.bookingDate + ' ' + bookingProps.bookingTime, 'MMM, YYYY hh:mm A', 'YYYY-MM-DD hh:mm A')}}</div>
                  </div>
                </div>
                <div class="col center-title ml-4">
                {{decodeURIComponent(bookingProps.locationName)}}
                </div>
              </div>
            </div>
            <div class="col p-0">
              <div class="row m-0">
                <div class="col-2 p-0">
                  <div class="rounded-image medium-rounded-image m-t-0 m-t-b is-icon" v-if="specialist.profileThumbnail" @click="tapReadMore(specialist.id)">
                    <div class="profile-image-content"><img :src="specialist.profileThumbnail" /></div>
                  </div>
                  <div class="box-col" v-else>
                    <div class="rounded-image medium-rounded-image m-t-0 m-t-b">
                      <div class="profile-image-content notice-background"><s class="text-initials">{{getInitials(specialist)}}</s></div>
                    </div>
                  </div>
                </div>
                <div class="col center-title">
                  <div>
                    <div class="name is-icon" @click="tapReadMore(specialist.id)">
                      {{specialist.fullName}}
                    </div>
                    <div class="">
                      {{getSpecialistInfo(specialist.practiceLocationId, specialist.locations)}}
                    </div>
                    <div class="is-icon">
                      <img v-if="booking.requiresTravel" class="icon-20 mr-2" src="@/assets/images/travel_black_circle_icon.svg" />
                      <img v-if="booking.videoLinkAvailable == 2" class="icon-20" src="@/assets/images/video_black_icon.svg" data-toggle="tooltip" data-placement="right" title="Appointment by Video Link" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pb-2" v-if="showResult">
            <span><b>Searching for: </b> <span v-if="user.type >=3">{{getName(searchOption.ClientID)}}</span></span>
            <span v-if="searchOption.DateofBirthFrom " class="ml-2"><b>Date of Birth: </b> {{formatDateTime(this.searchOption.DateofBirthFrom , 'DD/MM/YYYY')}}</span>&nbsp;
            <!-- <span class="ml-2"><b>case Reference: </b> {{searchOption.caseReference}}</span>&nbsp; -->
          </div>
          <div class="" v-if="showResult">
            <div class="table-responsive" style="max-height: 500px">
              <el-table v-if="cases.length > 0" ref="bookingTable" :default-sort="{prop: 'CaseID', order: 'descending'}" stripe @sort-change="sortParam" :data="cases" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}" :header-cell-style="{fontWeight: 100}">
                <el-table-column
                    width="100"
                    prop="CaseID"
                    label="ID"
                    sortable="custom"
                    show-overflow-tooltip
                    fixed="left"
                >
                  <template slot-scope="scope">
                    <span>{{
                        scope.row.id
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="Client"
                    sortable="custom"
                    label="Client"
                >
                  <template slot-scope="scope">
                    <span>{{
                        scope.row.clientBranchName
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="180"
                    show-overflow-tooltip
                    prop="Claimant"
                    sortable="custom"
                    label="Examinee Name"
                >
                  <template slot-scope="scope">
                    <span>{{
                        scope.row.claimantFullName
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    sortable="custom"
                    show-overflow-tooltip
                    prop="dateOfBirth"
                    label="Date of Birth"
                >
                  <template slot-scope="scope">
                    <span>{{
                        formatDate(scope.row.dateOfBirth, "DD/MM/YYYY")
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    prop="nextBookingDate"
                    label="Next Booking Date"
                >
                  <template slot-scope="scope">
                    <span>{{
                        formatDate(scope.row.nextBookingDate, "DD/MM/YYYY")
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="180"
                    show-overflow-tooltip
                    prop="numberBookings"
                    label="Number Of Booking"
                >
                </el-table-column>
                <el-table-column
                    width="120"
                    sortable="custom"
                    show-overflow-tooltip
                    prop="CaseStatus"
                    label="Status"
                >
                  <template slot-scope="scope">
                    <span>{{Number(scope.row.caseStatus) === 1 ? 'Active' : 'InActive'}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    prop="caseStatus"
                    label=" "
                >
                  <div class="icon-group" slot-scope="scope">
                    <v-btn class="submit-request" @click="selectCase(scope.row)" dark>Select Case</v-btn>
                  </div>
                </el-table-column>
              </el-table>
              <div v-else class="p-3">No cases found.</div>
            </div>
            <div class="table-responsive">
              <div v-if="totalCount > searchOption.pageSize" class="pagination">
                Page
                <div class="pagination-group">
                  <div class="border-icon pagination-current dropdown">
                    <div class="pagination-current-text">{{ searchOption.pageNum }}</div>
                    <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
                    <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                      <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/searchOption.pageSize))" :class="searchOption.pageNum === item ? 'selected' : ''" :value="item" :key="item" @click="selectPage(item)">
                        {{ item }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount/searchOption.pageSize) }}</div>
              </div>
            </div>
          </div>
          <div class="box-row item-right" v-if="showResult">
            </br>
            <div>
              <v-btn dark @click="tapAddNew()">Add New Examinee & Case</v-btn>
            </div>
          </div>

          <div class="box box-body search-details">
            <div class="box-heading d-flex justify-content-between align-items-center">
              <div>Find / Enter Examinee & Case Details</div>
              <v-btn v-if="!bookingProps.waitlisted && !bookingProps.isTentative" dark @click="switchToTentative">{{ !isTentative ? 'Tentative' : 'Book'}}</v-btn>
              <v-btn v-if="bookingProps.isTentative" dark @click="releaseBooking">Cancel</v-btn>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Examinee First Name</div>
              <div class="box-col box-col-right">
                <input :class="hasError && claimantFirstNameError ? 'is-invalid' : ''" type="text" v-model="searchOption.ClaimantFirstName" class="textbox referance"  placeholder="Click to enter part / all of the Examinee First Name" />
                <div class="text-danger" v-if="hasError && claimantFirstNameError">{{ claimantFirstNameError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Examinee Surname</div>
              <div class="box-col box-col-right">
                <input  :class="hasError && claimantSurnameError ? 'is-invalid' : ''" type="text" v-model="searchOption.ClaimantSurname " class="textbox referance"  placeholder="Click to enter part / all of the Examinee Surname" />
                <div class="text-danger" v-if="hasError && claimantSurnameError">{{ claimantSurnameError }}</div>
              </div>
            </div>
<!--            <div class="box-row">-->
<!--              <div class="box-col box-col-left">Reference Number</div>-->
<!--              <div class="box-col box-col-right">-->
<!--                <input type="text" v-model="searchOption.ReferenceNumber" class="textbox referance"  placeholder="Click to enter part / all of the Claimant Surname" />-->
<!--              </div>-->
<!--            </div>-->
            <div class="box-row">
              <div class="box-col box-col-left">Date of Birth</div>
              <div class="box-col box-col-right box-col-center">
                <el-date-picker
                    :class="hasError && !validateDateOfBirth ? 'is-invalid-datepicker' : ''"
                    v-model="dateValue"
                    type="date"
                    popper-class="date-range-picker-popper"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                    @change="changeDates"
                    placeholder="Birth Date"
                    clearable
                />
                <div class="text-danger" v-if="hasError && !validateDateOfBirth">Date of birth is required.</div>
              </div>
            </div>
            <!-- Ticket 5491 -->
            <!-- <div class="box-row">
              <div class="box-col box-col-left">case Reference</div>
              <div class="box-col box-col-right">
                <input type="text" v-model="searchOption.caseReference" class="textbox referance" placeholder="Click to enter part / all of the case Reference" />
              </div>
            </div> -->
            <div v-if="user.type >= 3" class="box-row">
              <div class="box-col box-col-left left-label">Client</div>
              <div class="box-col box-col-right align-items-center">
                <el-select :class="hasError && !validateClient ? 'is-invalid' : ''" class="referance" filterable clearable style="width: 260px" placeholder="Client Name" @change="changeClient" v-model="searchOption.ClientID">
                  <el-option v-for="item in listClients" :key="item.id" :value="item.id" :label="item.name">{{item.name}}</el-option>
                </el-select>
                <div class="text-danger" v-if="hasError && !validateClient">Client is required.</div>
              </div>
            </div>
            <div v-if="user.type >= 3 && searchOption.ClientID" class="box-row">
              <div class="box-col box-col-left left-label">Client Contact</div>
              <div class="box-col box-col-right">
                <el-select :class="hasError && !validateContact ? 'is-invalid' : ''"  filterable clearable style="width: 260px" placeholder="Client Contact" v-model="searchOption.contactId">
                  <el-option v-for="item in originalClientContacts" :key="item.id" :value="item.id" :label="item.name">{{item.name}}</el-option>
                </el-select>
                <button class="btn" data-toggle="tooltip" data-placement="right" title="Create New Contact" @click="addNewContact">
                  <img class="w-75" src="@/assets/images/add_black_icon.svg" />
                </button>
                <div class="text-danger" v-if="hasError && !validateContact">Client contact is required.</div>
              </div>
            </div>
            <div v-if="bookingProps.waitlisted" class="box-row">
              <div class="box-col box-col-left left-label">Reference Number</div>
              <div class="box-col box-col-right">
                <input type="text" v-model="searchOption.ReferenceNumber" maxlength="20" class="textbox referance" :class="hasError && referenceNumberError ? 'is-invalid' : ''" placeholder="Reference Number" @blur="trimReferenceNumber" />
                <div class="text-danger" v-if="hasError && referenceNumberError">{{ referenceNumberError }}</div>
              </div>
            </div>
          </div>
          <div class="box-row item-right">
            <div>
              <v-btn v-if="!bookingProps.waitlisted" class="submit-request" @click="tapSearch()" dark>{{isTentative ? 'PLACE HOLD' : 'Search'}}</v-btn>
              <v-btn v-else class="submit-request" @click="tapWaitList()" dark>WAITLIST</v-btn>
            </div>
          </div>

          <div class="alert alert-success hidden-element">
            <a class="close" title="close">×</a>
            <b>Success:</b> {{ successMessage }}
          </div>
          <div class="alert alert-danger hidden-element">
            <a class="close" title="close">×</a>
            <b>Error:</b> {{ errorMessage }}
          </div>

        </div>
      </div>
    </div>
    <Chat v-if="this.user.type < 3"/>
    <el-dialog title="Add New Contact"
               :visible.sync="showContactModal"
               @close="cancelDialog">
      <AdminEditClientContact :clientIdProps="searchOption.ClientID" @contactCreated="contactCreated" />
    </el-dialog>
  </div>
</template>
<script>

import utilities from '@/assets/js/utilities'
import AdminNavigation from "@/components/AdminNavigation";
import AdminBookingsMenu from "@/components/AdminBookingsMenu";
import Navigation from '@/components/Navigation'
import SpecialistMenu from '@/components/SpecialistMenu'
import Header from '@/components/Header'
import Chat from '@/components/Chat'
import ProfileReadMoreModal from '@/components/ProfileReadMoreModal'
import AdminEditClientContact from "@/components/AdminEditClientContact";

export default {
  name: 'SearchCaseLists',
  components: {
    AdminEditClientContact,
    AdminNavigation,
    AdminBookingsMenu,
    Navigation,
    SpecialistMenu,
    Header,
    Chat,
    ProfileReadMoreModal,
  },
  data() {
    return {
      totalCount: 0,
      dateValue: "",
      setDisabled: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      claimantFirstName: '',
      claimantLastName: '',
      searchOption: {
        pageNum: 1,
        pageSize: 10,
        CaseStatus: 1,
        ClientName: '',
        ClaimantSurname : '',
        ClaimantFirstName: '',
        ClientID: '',
        contactId: '',
        ReferenceNumber: '',
      },
      bookingProps: null,

      hasError: false,
      successMessage: '',
      errorMessage: '',
      searchData: '',

      showContent: true,
      isValidDateOfBirth: true,
      showResult: false,

      searchCase: [],
      specialist: [],
      originalListClients: [],
      listClients: [],
      cases: [],
      booking: [],
      showContactModal: false,
      isTentative: false,
      clients: [],
      originalClientContacts: [],
      listContact: [],
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
    referenceNumberError() {
      if (!this.bookingProps || !this.bookingProps.waitlisted) {
        return ''
      }
      return utilities.getAdminBookingClientReferenceError(this.searchOption.ReferenceNumber)
    },
    validateReferenceNumber() {
      return !this.referenceNumberError
    },
    validateContact() {
      return !(this.user.type >= 3 && (this.bookingProps.waitlisted || this.isTentative) && !this.searchOption.contactId);

    },
    validateDateOfBirth() {
      return this.dateValue;
    },
    validateClient() {
      return !(this.user.type >= 3 && !this.searchOption.ClientID);

    },
    claimantFirstNameError() {
      return utilities.getClientContactPersonNameError(this.searchOption.ClaimantFirstName, 'First name')
    },
    claimantSurnameError() {
      return utilities.getClientContactPersonNameError(this.searchOption.ClaimantSurname, 'Surname')
    },
  },

  methods: {
    trimReferenceNumber() {
      if (this.searchOption.ReferenceNumber === undefined || this.searchOption.ReferenceNumber === null) {
        return
      }
      this.searchOption.ReferenceNumber = String(this.searchOption.ReferenceNumber).trim()
    },
    contactCreated() {
      this.cancelDialog();
      this.changeClient()
    },
    cancelDialog() {
      this.showContactModal = false
    },
    addNewContact() {
      this.showContactModal = true
    },
    releaseBooking() {
      if(!this.bookingProps.tentativeBookingID) return
      this.$confirm({
        content: 'Are you sure you want to release this Tentative Booking?',
        onConfirm: async () => {
          this.$store.dispatch('loading/setLoadComponent', true)
          const param = {
            Status: 2
          }
          await utilities.putTentativeBooking(this.bookingProps.tentativeBookingID, param)
          this.$store.dispatch('loading/setLoadComponent', false)
          this.$notify({
            dangerouslyUseHTMLString: true,
            message: '<div class="alert-success">' +
                '            <b>Success:</b> Booking released' +
                '          </div>',
          });
          this.$router.go(-1)
        }
      })
    },
    switchToTentative() {
      this.isTentative = !this.isTentative
    },
    getName(id) {
      return this.clients.find(item => item.id === id).name
    },
    sortParam( v ) {
      this.searchOption.orderBy = v.prop
      if(v.order === "ascending") {
        this.searchOption.ascOrDesc = 'ASC'
      } else if (v.order === "descending") {
        this.searchOption.ascOrDesc = 'DESC'
      } else {
        this.searchOption.orderBy = null
        this.searchOption.ascOrDesc = null
      }

      this.selectPage(1)
    },
    async selectPage(index) {
      this.searchOption.pageNum = index
      await this.$store.dispatch('loading/setLoadComponent', true)
      let obj = {
        ClaimantFirstName: this.searchOption.ClaimantFirstName,
        ClaimantSurname: this.searchOption.ClaimantSurname,
        DateofBirth: this.searchOption.DateofBirthFrom,
      }
      if(this.user.type >= 3) {
        obj.ClientID = this.searchOption.ClientID
      }
      const {clientCase, total} = await utilities.getCasesDuplicate(obj)
      this.cases = clientCase
      console.log(cases)
      this.totalCount = total
      await this.$store.dispatch('loading/setLoadComponent', false)
    },
    changeDates(v) {
      if(v) {
        this.searchOption.DateofBirthFrom = v
        this.searchOption.DateofBirthTo  = v
      } else {
        this.searchOption.DateofBirthFrom = null
        this.searchOption.DateofBirthTo  = null
      }
      this.$forceUpdate()
    },
    setTitle() {
      var title = "Create a Booking - case Details"
      if (this.bookingProps.waitlisted) {
        title = "Create a Waitlist Booking - case Details"
      }
      return title
    },

    getInitials(specialist) {
      var initials = ""
      if (specialist.firstName) {
        initials = specialist.firstName.substring(0,1)
      }

      if (specialist.lastName) {
        initials = initials + specialist.lastName.substring(0,1)
      }
      return initials
    },

    clientSelected(item) {
      if (item.id != undefined) {
        this.searchOption.clientId = item.id
        if (this.searchOption.clientId) {
          this.changeClient()
        }
      }
    },

    contactSelected(item) {
      if (item.id != undefined) {
        this.item = item
        this.searchOption.contactId = item.id
      }
    },

    filterContact(text) {
      this.listContact = this.originalClientContacts.filter((item) => item.name.toLowerCase().indexOf(text.toLowerCase()) > -1)
    },

    async changeClient() {
      this.searchOption.contactId = null
      this.searchOption.ClientName = this.listClients.find(item => item.id === this.searchOption.ClientID).name
      await this.$store.dispatch('loading/setLoadComponent', true)
      if(this.searchOption.clientId != '') {
        this.contacts = await utilities.choiceGetContact(this.searchOption.ClientID)
        this.originalClientContacts = _.cloneDeep(utilities.getClientsDropdownAutoCompleteTag(this.contacts, false))
        this.listContact = this.originalClientContacts.map(item => item.name)
      }
      else {
        this.contacts = []
      }
      await this.$store.dispatch('loading/setLoadComponent', false)
    },
    async createTentative() {
      const param = {
        BookingTypeID: this.bookingProps.typeId || 0,
        ClientID: this.user.type >= 3 ? this.searchOption.ClientID : this.user.clientId,
        SpecialistID: this.bookingProps.id,
        ClaimantFirstName: this.searchOption.ClaimantFirstName,
        ClaimantSurname: this.searchOption.ClaimantSurname ,
        DateofBirth: this.searchOption.DateofBirthFrom,
        ClientContactID: this.user.type >= 3 ? this.searchOption.contactId : this.user.ClientContact?.ClientContactID,
        BookingDate: this.bookingProps.bookingDate,
        AvailabilityID: this.bookingProps.availabilityId,
        DateSubmitted: window.moment().format('YYYY-MM-DD HH:mm:ss'),
        DeliveryMethodIDs: this.bookingProps.deliveryMethods ? this.bookingProps.deliveryMethods : undefined,
      }
      await this.$store.dispatch('loading/setLoadComponent', true)
      await utilities.postTentativeBooking(param)
      await this.$store.dispatch('loading/setLoadComponent', false)
      await this.$router.push('/admin-bookings-tentative')
    },

    async tapWaitList() {
      this.hasError = false
      if (!this.validateClient || this.claimantFirstNameError || this.claimantSurnameError || !this.validateContact || !this.validateReferenceNumber || !this.validateDateOfBirth) {
        this.hasError = true
        return
      }
      const param = {
        BookingTypeID: this.bookingProps.typeId || 0,
        ClientID: this.searchOption.ClientID || this.user.clientId,
        SpecialistID: this.bookingProps.id,
        ClaimantFirstName: this.searchOption.ClaimantFirstName,
        ClaimantSurname: this.searchOption.ClaimantSurname ,
        DateofBirth: this.searchOption.DateofBirthFrom,
        ClientContactID: this.searchOption.contactId || this.user.ClientContact?.ClientContactID,
        CaseReference: this.searchOption.ReferenceNumber,
        LocationID: this.bookingProps.locationId,
        RequestedDay: this.bookingProps.bookingDate,
        DateSubmitted: window.moment().format('YYYY-MM-DD HH:mm:ss'),
      }

      await this.$store.dispatch('loading/setLoadComponent', true)
      await utilities.postWaitlistBooking(param, () => {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<div class="alert-success">' +
              '            <b>Success:</b> Waitlist booking created' +
              '          </div>',
        });
        this.$router.push({name: 'admin-bookings-waitlisted'})
      })
      await this.$store.dispatch('loading/setLoadComponent', false)
    },

    async tapSearch() {
      this.hasError = false
      console.log(this.validateDateOfBirth)
      if (!this.validateClient || this.claimantFirstNameError || this.claimantSurnameError || !this.validateDateOfBirth || !this.validateContact ) {
        this.hasError = true
        this.errorMessage = "Please correct the errors shown above and try again."
        utilities.showAlert(".alert-danger")
        return
      }
      if(this.isTentative) {
        await this.createTentative()
        return
      }
      await this.$store.dispatch('loading/setLoadComponent', true)

      if (this.user.type >= 3) {
        this.searchOption.ClientID = this.searchOption.ClientID
      } else {
        // params.Cc = 1
        this.searchOption.ClientID = this.user.clientId
      }

      this.cases = []
      let obj = {
        ClaimantFirstName: this.searchOption.ClaimantFirstName,
        ClaimantSurname: this.searchOption.ClaimantSurname,
        DateofBirth: this.searchOption.DateofBirthFrom,
      }

      if(this.user.type >= 3) {
        obj.ClientID = this.searchOption.ClientID
      }

      const {clientCase, total} = await utilities.getCasesDuplicate(obj)
      this.cases = clientCase
      this.totalCount = total
      this.showResult = true
      await this.$store.dispatch('loading/setLoadComponent', false)
    },

    getLocationName(fullLocation = false) {
      if (this.booking.locationId && this.locations.length > 0) {
        if (fullLocation) {
          return this.locations.find((x) => x.id == this.booking.locationId).fullLocation.replace(', Australia', "")
        } else {
          return this.locations.find((x) => x.id == this.booking.locationId).shortLocation
        }

      }
      return ""
    },

    async selectCase(item) {
      utilities.clearChangingObject()
      this.bookingProps.caseId = item.id
      this.bookingProps.isNewCase = false
      this.bookingProps.ClientContactID = this.user.type >= 3 ? this.searchOption.contactId : this.user.ClientContact?.ClientContactID
      this.bookingProps.originalClientContacts = this.originalClientContacts
      this.bookingProps.ClientName = this.searchOption.ClientName
      this.bookingProps.dateOfBirth = window.moment(item.dateOfBirth, "YYYY-MM-DD").format('YYYY-MM-DD')
      await this.$store.dispatch("booking/setBookingObject", this.bookingProps)
      if (this.user.type >= 3) {
        await this.$store.dispatch('loading/setLoadComponent', true)
        const result = await utilities.getRedAlerts({ClientID: item.clientId})
        await this.$store.dispatch('loading/setLoadComponent', false)
        if(result && result.length > 0) {
          this.$alert(result[0].Note, 'Client Red Alert', {
            confirmButtonText: 'OK',
            callback: () => {
              this.bookingProps.clientId = item.clientId
              this.$store.dispatch("booking/setBookingObject", this.bookingProps)
              this.$router.push({
                name: 'admin-create-new-booking',
                query: {clientId: item.clientId},
                params: {bookingProps: this.bookingProps}
              }).catch((err) => {
              })
            }
          })
        } else {
          this.bookingProps.clientId = item.clientId
          this.bookingProps.ClientName = this.searchOption.ClientName
          this.$store.dispatch("booking/setBookingObject", this.bookingProps)
          this.$router.push({
            name: 'admin-create-new-booking',
            query: {clientId: item.clientId},
            params: {bookingProps: this.bookingProps}
          }).catch((err) => {
          })
        }
      } else {
        await this.$store.dispatch("booking/setBookingObject", this.bookingProps)
        this.$router.push({name: 'manage-booking', params: {bookingProps: this.bookingProps}}).catch((err) => {
        })
      }
    },

    async tapAddNew() {
      this.bookingProps.isNewCase = true
      this.bookingProps.caseId = ''
      this.bookingProps.dateOfBirth = window.moment(this.searchOption.DateofBirthFrom, "YYYY-MM-DD").format('YYYY-MM-DD')
      this.bookingProps.claimantFirstName = this.searchOption.ClaimantFirstName
      this.bookingProps.claimantLastName = this.searchOption.ClaimantSurname
      this.bookingProps.caseReference = this.searchOption.ReferenceNumber
      this.bookingProps.originalClientContacts = this.originalClientContacts
      this.bookingProps.ClientName = this.searchOption.ClientName

      if (this.user.type >= 3) {
        this.bookingProps.clientId = this.searchOption.ClientID
        this.bookingProps.ClientContactID = this.searchOption.contactId
      } else {
        this.bookingProps.ClientContactID = this.user.ClientContact?.ClientContactID
      }
      this.$store.dispatch("booking/setBookingObject", this.bookingProps)
      if (this.user.type >= 3) {
        await this.$store.dispatch('loading/setLoadComponent', true)
        const result = await utilities.getRedAlerts({ClientID: this.searchOption.ClientID})
        await this.$store.dispatch('loading/setLoadComponent', false)
        if(result && result.length > 0) {
          this.$alert(result[0].Note, 'Client Red Alert', {
            confirmButtonText: 'OK',
            callback: () => {
              this.$router.push({
                name: 'admin-create-new-booking',
                params: {bookingProps: this.bookingProps}
              }).catch((err) => {
              })
            }
          })
        } else {
          this.$router.push({
            name: 'admin-create-new-booking',
            params: {bookingProps: this.bookingProps}
          }).catch((err) => {
          })
        }
      } else {
        this.$router.push({name: 'manage-booking', params: {bookingProps: this.bookingProps}}).catch((err) => {
        })
      }
    },

    tapReadMore(index) {
      this.$refs.profileReadMoreModal.loadData(index)
      this.$refs.profileReadMoreModal.handleModal()
    },

    getSpecialistInfo(locationId, locations) {
      var text = ""
      if (this.specialist.qualificationList) {
        text = this.specialist.qualificationList
        return text
      }

      // if (locationId) {
      //   var value = locations.find((x) => x.id == locationId).shortLocation
      //   if (value) {
      //     if (text.length == 0) {
      //       return value
      //     } else {
      //       return text + ", " + value
      //     }
      //   }
      // }
      return ""
    },

    formatDateTime(date, format, currentFormat = "YYYY-MM-DD") {
      if (date != '') {
        if (format == 'MMM, YYYY hh:mm A' && this.booking.bookingStatus == 16) {
          format = 'MMM, YYYY'
          return utilities.formatDate(date, format, currentFormat)
        } else {
          return utilities.formatDate(date, format, currentFormat)
        }
      }
      return ''
    },

    formatDate(dateToFormat) {
      console.log(dateToFormat)
      return utilities.formatDate(dateToFormat, 'DD/MM/YYYY')
    },

    async loadData() {
      if (this.user.type >=3) {
        this.clients = await utilities.getClients();
        this.originalListClients = _.cloneDeep(utilities.getDropdownAutoCompleteTag(this.clients))
        this.listClients = this.originalListClients
        if (this.bookingProps.clientId) {
          this.searchOption.ClientID = this.bookingProps.clientId
          this.searchOption.ClientName = this.listClients.find(item => item.id === this.searchOption.ClientID).name
          this.contacts = await utilities.choiceGetContact(this.bookingProps.clientId)
          this.originalClientContacts = _.cloneDeep(utilities.getClientsDropdownAutoCompleteTag(this.contacts, false))
          this.listContact = this.originalClientContacts.map(item => item.name)
        }
      }
    },
    setDefaultInput(bookingObj) {
      this.searchOption.ClaimantFirstName = bookingObj.claimantFirstName
      this.searchOption.ClaimantSurname  = bookingObj.claimantSurname
      this.searchOption.ClientID = bookingObj.clientId
      this.searchOption.contactId = bookingObj.caseOwner
      this.searchOption.DateofBirthFrom = bookingObj.DateofBirth
      this.searchOption.ReferenceNumber = bookingObj.caseReference
      this.dateValue = bookingObj.DateofBirth
      console.log(this.searchOption)
    }
  },

  async beforeMount() {
    this.bookingProps = this.$store.getters["booking/getBookingObject"]
    // console.log("BookingProps")
    this.bookingProps.isNewCase = false
    this.bookingProps.noResult = false
    if (this.bookingProps == null) {
      if (this.user.type >= 3) {
        this.$router.push({ name: 'management'}).catch((err) => {})
      } else {
        this.$router.push({ name: 'home'}).catch((err) => {})
      }
      return
    }
    if(this.bookingProps.claimantFirstName) this.searchOption.ClaimantFirstName = this.bookingProps.claimantFirstName
    if(this.bookingProps.claimantSurname)this.searchOption.ClaimantSurname  = this.bookingProps.claimantSurname
    if(this.bookingProps.caseOwner) this.searchOption.contactId = this.bookingProps.caseOwner
    if(this.bookingProps.dateOfBirth) {
      this.dateValue = this.bookingProps.dateOfBirth
      this.searchOption.DateofBirthFrom = this.bookingProps.dateOfBirth
      this.searchOption.DateofBirthTo  = this.bookingProps.dateOfBirth
    }
    if(this.bookingProps.isTentative || this.bookingProps.WaitListPreBookingID) {
      this.setDefaultInput(this.bookingProps)
    }
    await this.$store.dispatch("booking/setBookingObject", this.bookingProps)
    this.$watch(
        () => this.user,
        async (newVal, oldVal) => {
          console.log(newVal)
          if (newVal) {
            await this.$store.dispatch('loading/setLoadComponent', true)
            utilities.getSpecialistById(this.bookingProps.id).then(r => {
              this.specialist = r
            })
            await this.loadData()
            await this.$store.dispatch('loading/setLoadComponent', false)
          }
        },
        { immediate: true, deep: true }
    )
  },
  mounted() {
    setTimeout((x) => {
      $(".dropdown-input").attr({
       autocomplete: "off",
      });
    }, 500)
  },
}
</script>
